import React from 'react'
import useStyles from '../styles'
import { Typography, useMediaQuery } from '@material-ui/core'
import TextClamp from 'react-string-clamp'
import ItemType from './ItemType'
import { useDispatch } from 'react-redux'
import { openDialog } from 'actions/dialogs'
import useBidAmount from 'hooks/useBidAmount'
// import { useSelector } from 'react-redux'

const Item = ({ item, onClick, showWinner }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const bidAmount = useBidAmount(item)
  const isMobile = useMediaQuery('(max-width: 767px)')
  // const authenticatedUser = useSelector(
  //   state => state.authentication.authenticatedUser
  // )
  // const won = item.high_bid_user_id === authenticatedUser.user_id && showWinner
  return (
    <div
      className={classes.item}
      onClick={() => {
        if (!isMobile) {
          dispatch(openDialog('item', item))
        }
      }}
    >
      <div
        className={classes.itemImage}
        style={{
          backgroundImage: `url(${item.image[0] ? item.image[0].url : ''})`
        }}
      >
        {/* {won && <div>YOU WON THIS!!!</div>} */}
        <ItemType className={classes.itemType} item={item} />
      </div>
      <div className={classes.bottomContent}>
        <span className={classes.itemName}>
          <TextClamp
            className={classes.itemNameTypography}
            text={item.name}
            lines={1}
          />
        </span>
        <span className={classes.itemCost}>
          <Typography className={classes.itemCostTypography}>
            ${bidAmount}
          </Typography>
        </span>
      </div>
    </div>
  )
}

export default Item



// WEBPACK FOOTER //
// ./src/components/ItemsList/Item/index.jsx